<div class="official">
  <div class="official__image-rounded">
    <img class="portrait img-circle" src="{{ person.getImageUrl('medium') }}" alt="Official Image">
  </div>
  <div class="official__info">
    <div class="official__info-left">
      <div class="official__names">
        <h4>{{ person.getFullName() }}</h4>
        <h4 class="official__pos" matTooltip="{{ getFunctionsList() }}">
          {{ getFunctionsList() }}
        </h4>
      </div>
    </div>
    <div class="official__aside">
      <span class="official__aside-item mail" *ngIf="person.email != null"><a href="mailto:{{person.email}}">{{ person.email }}</a></span>
      <span class="official__aside-item" *ngIf="person.mobile_phone != null"><a href="tel:{{person.mobile_phone}}">{{ person.mobile_phone }}</a></span>
    </div>
  </div>
</div>
